module.exports = __webpack_public_path__ + "static/media/HEROMOTOCO_F1.d89492cb.txt";